import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthenticationContext } from '../../App';
import { toast } from 'react-toastify';
import axios from '../../axios/axios';
import { API } from '../../common/Constants';
import { useState } from 'react';
import TextArea from '../../components/Form/TextArea';
import { Button, Col, Row, Modal, DatePicker } from 'antd';
import dayjs from "dayjs";
import FileUploadWithThumb from '../../components/FileUploadWithThumb/FileUploadWithThum';
const ViewInvoice = ({ pdfurl }) => {
    const [popupOpen, setPopupOpen] = useState(false);
    const [invoiceReportValues, setInvoiceReportValues] = useState({
        invoice_start_date: "",
        invoice_remarks: "",
        invoice_disbursement_doc: [],
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.record;
    const applicationId = data.id
    const agentEmail = data?.agent_mail_address

    const handleInvoice = async () => {
        setLoading(true);
        try {
            await axios.post(
                `update/loan/application/invoice-status/${applicationId}`,
                {
                    ...invoiceReportValues,
                    agent_mail_address: agentEmail,
                }
            );
            setInvoiceReportValues({
                invoice_start_date: "",
                invoice_remarks: "",
                invoice_disbursement_doc: [],
            });
            toast.success("Payment request submitted successfully.");
            localStorage.setItem("startTimerForInvoice", true);
        } catch (error) {
            // toast.error("Failed to send payment details!");
            console.error(error);
        } finally {
            setLoading(false);
            setPopupOpen(false);
            navigate(-1);
        }
    };

    const handleFileUpload = async ({ file, onSuccess, onError }) => {
        const formData = new FormData();
        formData.append("file[]", file);
        formData.append("module", "loan_application");
        try {
            const response = await axios
                .post("/loan/application/document", formData)
                .then((resp) => {
                    setInvoiceReportValues({
                        ...invoiceReportValues,
                        invoice_disbursement_doc: invoiceReportValues?.invoice_disbursement_doc?.concat(
                            resp.data?.data
                        ),
                    });
                    toast.success(resp.data?.message);
                    onSuccess();
                });
        } catch (error) {
            onError(error);
        }
    };

    return (

        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-hidden">
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>View Invoice</p>
                        </div>
                    </Col>
                </Row >
            </div >
            <div className='min-[768px]:mx-[50px]'>
                <iframe src={`${API.BaseUrl}application/view-invoice/` + applicationId} className='h-[900px]' id='pdf' title="PDF Viewer" width="100%" />
            </div>
            <div className="bg-white text-center p-[18px_25px]" >
                <Row className="w-full h-full flex justify-end items-end">
                    <Col>
                        {data?.invoice_status_code === 1 && (
                            <Button
                                onClick={() => setPopupOpen(true)}
                                type="primary"
                            >
                                Paynow
                            </Button>
                        )}
                    </Col>
                </Row>
            </div >
            <Modal
                open={popupOpen}
                onCancel={() => {
                    setInvoiceReportValues({
                        invoice_start_date: "",
                        invoice_remarks: "",
                        invoice_disbursement_doc: [],
                    });
                    setPopupOpen(false);
                }}
                centered
                footer={null}
            >
                <div className="reject-popup-block">
                    <h2 className="text-center">Invoice Report</h2>
                    <div className="flex flex-col">
                        <label className="mb-1 text-sm font-medium text-gray-700">
                            Invoice Start Date
                        </label>
                        <DatePicker
                            placeholder="DD-MM-YYYY"
                            format="DD-MM-YYYY"
                            className="!w-full h-[40px] !rounded-lg !border-gray-300 focus:!border-blue-500 focus:!shadow-sm"
                            value={
                                invoiceReportValues.invoice_start_date
                                    ? dayjs(invoiceReportValues.invoice_start_date, "DD-MM-YYYY")
                                    : null
                            }
                            onChange={(date, dateString) =>
                                setInvoiceReportValues((prev) => ({
                                    ...prev,
                                    invoice_start_date: date ? dateString : "",
                                }))
                            }
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        />
                    </div>
                    <TextArea
                        label="Remarks"
                        placeholder="Remarks"
                        className="mt-3"
                        value={invoiceReportValues?.remarks}
                        onChange={(e) => {
                            setInvoiceReportValues({
                                ...invoiceReportValues,
                                invoice_remarks: e.target.value,
                            });
                        }}
                    />
                    <FileUploadWithThumb
                        label={"Upload Invoice Documents"}
                        onFileUpload={() => { }}
                        CustomFileUpload={handleFileUpload}
                        maxCount={10}
                        onRemove={(file) => {
                            setInvoiceReportValues({
                                ...invoiceReportValues,
                                invoice_disbursement_doc: invoiceReportValues?.invoice_disbursement_doc?.filter(
                                    (it) => it?.name !== file?.name
                                ),
                            });
                        }}
                        isClose={invoiceReportValues?.invoice_disbursement_doc?.length < 1}
                    />
                    <div className="reject-popup-btn">
                        <Button
                            type="button"
                            className="can_btn"
                            onClick={() => {
                                setInvoiceReportValues({
                                    invoice_start_date: "",
                                    invoice_remarks: "",
                                    invoice_disbursement_doc: [],
                                });
                                setPopupOpen(false);
                            }}
                        >
                            Close
                        </Button>
                        <Button
                            className="sav_btn"
                            onClick={handleInvoice}
                            loading={loading}
                            disabled={
                                loading ||
                                Object.values(invoiceReportValues).filter(it => {
                                    if (Array.isArray(it)) return it.length > 0;
                                    return it !== "" && it !== null;
                                }).length < 3
                            }
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </Modal>
        </div >
    );
};
export default ViewInvoice; 